export const TipoPraticaSimulado = {

  TREINO: { id: 1, nome: 'Treino' },
  PROVA: { id: 2, nome: 'Prova' }

}

export default TipoPraticaSimulado
